import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=1aeb76a2&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aeb76a2')) {
      api.createRecord('1aeb76a2', component.options)
    } else {
      api.reload('1aeb76a2', component.options)
    }
    module.hot.accept("./Invoices.vue?vue&type=template&id=1aeb76a2&", function () {
      api.rerender('1aeb76a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/invoices/Invoices.vue"
export default component.exports